export default __webpack_public_path__ + "static/media/ans6.74c28975.png";